import { CheckoutDescription } from ".";
import { usePaywallCheckoutContext } from "@circle-react/contexts/Paywalls/paywallCheckoutContext";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { CheckoutForm } from "../CheckoutForm";
import { PricePreview } from "../CheckoutForm/PricePreview";
import { Column } from "../components/Column";

interface RootProps {
  className?: string;
}

export const Root = ({ className }: RootProps) => {
  const { authProviderProperties } = usePaywallCheckoutContext();

  return (
    <Column
      className={classNames(
        "flex flex-row-reverse justify-center lg:justify-normal",
        className,
        {
          "pointer-events-none !hidden opacity-60 lg:!flex":
            authProviderProperties?.is_sso_authentication_required,
        },
      )}
    >
      <CheckoutDescription.CommunityHeader />
      <div
        className="bg-primary border-primary flex h-fit w-full flex-col rounded-xl border shadow-lg"
        data-testid="paywall-checkout-info"
      >
        <CheckoutDescription.Cover />
        <div className="flex flex-col gap-y-4 p-4 pb-5 md:p-7">
          <CheckoutDescription.PriceSelector />
          <CheckoutForm.CouponForm className="pb-4" />
          <PricePreview variant="with_modals" />
        </div>
      </div>
    </Column>
  );
};
